import { push } from "redux-first-history";
import { serverUrl } from "global";
import { mapIncoming } from "infrastructure/mapping/Mapping";
import { UiMessage, UiMessageType } from "models/UiMessageModel";
import { Middleware, MiddlewareAPI } from "redux";
import { LoginUserActionType } from "redux/actions/LoginUserActions";
import { MachineMaintenanceActionType } from "redux/actions/settings/MachineMaintenanceActions";
import { ModalActionType } from "redux/actions/ModalActions";
import { ProcessingRequestActionType } from "redux/actions/ProcessingRequestActions";
import { UiMessageActionType } from "redux/actions/UiMessageActions";

export const apiMiddleware: Middleware = ({
    dispatch
}: MiddlewareAPI) => next => (action: any) => {
    if (!action.meta || !action.meta.isApiCall) {
        return next(action);
    }
    const { successAction, errorAction, url, params, closeModal, emitSuccessMessage } = action.payload;
    if (emitSuccessMessage || action.type === LoginUserActionType.LOGIN_USER) {
        dispatch({
            type: ProcessingRequestActionType.ACTIVE
        })
    }
    return fetch(serverUrl + url, params)
        .then(async res => {
            if (emitSuccessMessage || action.type === LoginUserActionType.LOGIN_USER) {
                dispatch({
                    type: ProcessingRequestActionType.DONE
                })
            }
            if (res.status === 404) {
                dispatch({
                    type: UiMessageActionType.SHOW,
                    messageData: [new UiMessage('The requested ressource could not be found', UiMessageType.error, false)]
                })
                return { status: res.status, body: undefined }
            }
            if (res.status === 403) { // the backend sends no body here
                dispatch({
                    type: UiMessageActionType.SHOW,
                    messageData: [new UiMessage('Not included in your subscription', UiMessageType.error, false)]
                })
                return { status: res.status, body: undefined }
            }
            if (res.status === 500) {
                dispatch({
                    type: UiMessageActionType.SHOW,
                    messageData: [new UiMessage('Something went wrong...', UiMessageType.error, false)]
                })
                return { status: res.status, body: undefined }
            }
            if (res.status === 401 && errorAction !== LoginUserActionType.LOGIN_ERROR) {
                dispatch({
                    type: LoginUserActionType.LOGOFF_USER,
                    token: ""
                })
                const body = await res.json()
                return { status: res.status, body: body }
            } else {
                if (res.status === 202 || res.status === 204) { // Add, update and delete will send their updates via SignalR
                    return { status: res.status, body: undefined }
                } else {
                    const body = await res.json()
                    return { status: res.status, body: body }
                }
            }
        })
        .then(res => {
            if (res?.status === 200 || res?.status === 201 || res?.status === 202 || res?.status === 204) {
                if (res && res.body) {
                    dispatch({
                        type: successAction,
                        ...mapIncoming(successAction, res!.body)
                    })
                }
                if (successAction === LoginUserActionType.DELETE_ACCOUNT_SUCCESS) {
                    dispatch({
                        type: LoginUserActionType.DELETE_ACCOUNT_SUCCESS
                    })
                }
                if (successAction === LoginUserActionType.CONFIRM_DELETE_ACCOUNT_SUCCESS) {
                    dispatch({
                        type: LoginUserActionType.CONFIRM_DELETE_ACCOUNT_SUCCESS
                    })
                    dispatch(push('/Delete/Success'));
                }
                if (closeModal) {
                    dispatch({
                        type: ModalActionType.CLOSE_MODAL
                    })
                }
                if (emitSuccessMessage) {
                    dispatch({
                        type: UiMessageActionType.SHOW,
                        messageData: [new UiMessage('Success', UiMessageType.success, true)]
                    })
                }
                if (successAction === LoginUserActionType.REGISTER_USER_SUCCESS) {
                    // registration gives no token, login only works once the email is confirmed
                    dispatch({
                        type: UiMessageActionType.SHOW,
                        messageData: [new UiMessage('Please confirm your email with the link we sent you, then log in', UiMessageType.warning, true)]
                    })
                }
                if (successAction === LoginUserActionType.REGISTER_USER_SUCCESS || successAction === LoginUserActionType.SETNEW_PASSWORD_SUCCESS) {
                    dispatch(push('/'));
                }
                if (successAction === MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE_SUCCESS || successAction === MachineMaintenanceActionType.EDIT_MACHINEMAINTENANCE_SUCCESS) {
                    dispatch(push('/MachineMaintenances')); // leave the form only once the save went through
                }
            } else {
                var messages: UiMessage[] = [];
                if (errorAction === LoginUserActionType.LOGIN_ERROR) {
                    messages = [new UiMessage(res.body.message, UiMessageType.error, false)];
                    dispatch({
                        type: UiMessageActionType.SHOW,
                        messageData: messages
                    })
                }
                if (res.body.errors && res.body.errors.length > 0) {
                    messages = res.body.errors.map((error: string) => {
                        return new UiMessage(error, UiMessageType.error, false)
                    })
                    dispatch({
                        type: UiMessageActionType.SHOW,
                        messageData: messages
                    })
                }
            }
        }
        )
        .catch(res =>
            dispatch({
                type: errorAction,
                payload: res
            })
        );
};